export const SHOW_HISTROY_CONFIG = {
  liantong: 'true'
}